import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import { GameSelectionMenu } from '@/controller/components/GameSelectionMenu';
import { GameInfo } from '@/types';
import { absolute, FlexColumn, fullSize } from '@toilet-paper-games/ui';

import { config } from '@/common/config';
import { reaction } from 'mobx';
import { ControllerGamePlayer } from '../components/ControllerGamePlayer';
import { useControllerAppModel } from '../models/ControllerAppModel';

export const Lobby = observer(() => {
  const appStore = useControllerAppModel();

  // const [tempShowLobbyGame, setTempShowLobbyGame] = useState(false);

  const networkHandler = appStore.networkHandler;
  const hostConnection = networkHandler.hostConnection;
  if (!hostConnection) {
    throw new Error('No host connection');
  }

  return (
    <FlexColumn css={[fullSize, { zIndex: 200 }]} alignItems="center">
      <GameSelectionMenu />
      {/* {tempShowLobbyGame && <LobbyGame />} */}
      {/* <div css={[absolute(), { bottom: 0, left: 0, opacity: 0.5 }, { zIndex: 150 }]}>
        <Checkbox
          checked={tempShowLobbyGame}
          onClick={() => setTempShowLobbyGame(!tempShowLobbyGame)}
        />
      </div> */}
    </FlexColumn>
  );
});

export interface LobbyGameProps {
  className?: string;
}

const LobbyGame = observer((props: LobbyGameProps) => {
  const { className } = props;
  const appStore = useControllerAppModel();

  const [game, setGame] = useState<GameInfo | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const loadDevGame = () => {
    setLoading(true);
    async function gameFetcher() {
      setGame(await appStore.getGame(config.startScreenGame));
      setLoading(false);
    }
    gameFetcher();
  };

  useEffect(() => {
    const disposer = reaction(
      () => appStore.devGameUrl,
      () => !game && loadDevGame(),
    );

    return () => {
      disposer();
    };
  }, [game]);

  useEffect(loadDevGame, []);

  if (!game || loading || !appStore.user) {
    return null;
  }

  return (
    <div className={className} css={[fullSize, absolute(), { zIndex: 100 }]}>
      <ControllerGamePlayer lobbyGame={true} game={game} />
    </div>
  );
});
